import { useState, Fragment, useEffect } from "react";
import { useSidebar } from "../SidebarContext";
import { getCompanyData, getCompanyId } from "../../utils/utilityFunctions/localServices";
import Permission from "../CompanyAndPermission/ManagePermission/Permission";
import Group from "../CompanyAndPermission/ManagePermission/Group";
import CompanyDelegation2 from "./CompanyDelegation2";

const CompanyPage2 = ({ addCompanyID }) => {
  const TABS_OPTIONS = [
    {
      name: "Company Delegation",
      value: "company_delegation",
      icon: "bi bi-building",
      component: CompanyDelegation2,
    },
    {
      name: "Group",
      value: "group",
      icon: "bi bi-shield-lock-fill",
      component: Group,
    },
    {
      name: "Permission",
      value: "permission",
      icon: "bi bi-shield-lock-fill",
      component: Permission,
    },
  ];

  const [selectedTabOption, setSelectedTabOption] = useState(TABS_OPTIONS[0]);

  const handleTabChange = (tabValue) => {
    setSelectedTabOption(tabValue);
  };

  // TO GET AND SET THE COMPANY NAME IN HEADER
  // const sidebarContext = useSidebar();
  // const setheaderProps = sidebarContext?.setheaderProps;
  // useEffect(() => {
  //   setheaderProps({ name: getCompanyData()?.company_name || "" });
  // }, [setheaderProps]);

  {
    /* Tab Switch Component */
  }
  const TabSwitch = () => (
    <div className="flex items-center gap-3 bg-white rounded-md ">
      {TABS_OPTIONS.map((tab) => (
        <button
          key={tab?.value}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg rounded-b-none ${tab?.value === selectedTabOption?.value ? "bg-[#1D4469] text-white" : "text-[#888]"}`}
          onClick={() => {
            handleTabChange(tab);
          }}
        >
          {/* <i className={tab.icon}></i> */}
          {tab.name}
        </button>
      ))}
    </div>
  );

  return (
    <Fragment>
      <div className="p-4 h-full w-full" id="innercontent">
        <div
          id="default-styled-tab-content"
          className="tablemaindiv h-full"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {/* {selectedTabOption?.value === "company_delegation" ? (
            <div className="flex flex-col grow min-h-0">
              <CompanyDelegation />
            </div>
          ) : (
            <div className="flex flex-col grow min-h-0">
              <ManagePermission />
            </div>
          )} */}
          {selectedTabOption?.component && <selectedTabOption.component TabSwitch={TabSwitch} />}
        </div>
      </div>
    </Fragment>
  );
};

export default CompanyPage2;
